import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/variables.css";
import "./styles/global.css";
import "./styles/layout.css";
import "./styles/modal.css";
import "./styles/forms.css";
import "./styles/toast.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
